import type { ComponentProps } from 'solid-js'
import { splitProps } from 'solid-js'

import { FORM_CONTROL_CLASS } from './formControlClass'

/**
 * Renders a themed text-like input (`text`, `number`, `date`, and so on via
 * the `type` prop).
 *
 * @param props - Standard input props.
 * @returns The input element.
 */
const TextInput = (props: ComponentProps<'input'>) => {
   const [local, rest] = splitProps(props, ['class'])
   return (
      <input
         {...rest}
         class={[FORM_CONTROL_CLASS, local.class].filter(Boolean).join(' ')}
      />
   )
}

export default TextInput
